import { createContext } from 'react';

import { StepperSize } from './types';

export const InternalContext = createContext<{
  size: StepperSize;
  inverse: boolean;
}>(undefined as never);
